import { render, staticRenderFns } from "./Cabecera.vue?vue&type=template&id=a7f2dbba"
import script from "./Cabecera.vue?vue&type=script&lang=js"
export * from "./Cabecera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports